import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { getModuleRoles } from "@/api/moduleRole.service";
import { UserRoles } from "@/api/user.service";
import { ESCALA_ROLES, MODULE_ID } from "@/api/escala.service";

// Gerente e Administrador de Escala — qualquer papel acima de
// Encarregado (appdono/CLAUDE.md "Papéis"). É o papel mínimo que os
// relatórios da Escala exigem (decisão de 2026-09-28): relatório é visão da
// loja inteira, não o filtro de autoria que só o Encarregado tem. Mesmo
// padrão de useAdministradorEscala, só que testando um degrau mais baixo da
// hierarquia.
const PAPEIS_GERENTE_OU_ACIMA: string[] = ESCALA_ROLES.slice(1);

export function useGerenteDeEscala(): { podeVerRelatorios: boolean; carregando: boolean } {
  const { user } = useAuth();
  const userId = user!.id;
  const clientId = user!.loggedClient!.id;
  const adminDaPlataforma = user!.role === UserRoles.Admin;
  const [podeVerRelatorios, setPodeVerRelatorios] = useState(false);
  const [carregando, setCarregando] = useState(!adminDaPlataforma);

  useEffect(() => {
    if (adminDaPlataforma) return;
    let cancelado = false;
    setCarregando(true);
    getModuleRoles(userId, clientId, MODULE_ID)
      .then(({ roles }) => !cancelado && setPodeVerRelatorios((roles ?? []).some((r) => PAPEIS_GERENTE_OU_ACIMA.includes(r))))
      .catch(() => !cancelado && setPodeVerRelatorios(false))
      .finally(() => !cancelado && setCarregando(false));
    return () => {
      cancelado = true;
    };
  }, [adminDaPlataforma, clientId, userId]);

  return { podeVerRelatorios: adminDaPlataforma || podeVerRelatorios, carregando };
}
